module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020-desktop/0149.jpg?v=da2d32b1";